import { render, staticRenderFns } from "./ReportRemarkImportantCheckbox.vue?vue&type=template&id=422170e1&"
import script from "./ReportRemarkImportantCheckbox.vue?vue&type=script&lang=js&"
export * from "./ReportRemarkImportantCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCheckbox,QTooltip} from 'quasar'
component.options.components = Object.assign({QCheckbox,QTooltip}, component.options.components || {})
